'use client'
import { cn } from '@/lib/utils'
import { MessageDescriptor } from '@lingui/core'
import { useLingui } from '@lingui/react'
import { motion } from 'framer-motion'
import * as React from 'react'

export type SiteHeadingProps = {
  title?: MessageDescriptor
  description?: MessageDescriptor
  description2?: MessageDescriptor
  className?: string
  classNameWrapper?: string
}

export function SiteHeadingV2({
  title,
  description2,
  description,
  className,
  classNameWrapper
}: SiteHeadingProps): React.JSX.Element {
  const { i18n } = useLingui()

  return (
    <div
      className={cn(
        'relative flex flex-col items-center justify-center space-y-4 text-center',
        classNameWrapper
      )}
    >
      {title && (
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className='font-semibold leading-normal bg-text-gradient'
        >
          {i18n._(title)}
        </motion.h2>
      )}
      <div>
        {description && (
          <motion.p
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className={cn(
              'font-jakarta text-lg md:text-xl xl:text-2xl max-w-5xl font-light leading-relaxed',
              className
            )}
          >
            {i18n._(description)}
          </motion.p>
        )}
        {description2 && (
          <motion.p
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className={cn(
              'font-jakarta text-lg md:text-xl xl:text-2xl max-w-5xl font-light leading-relaxed',
              className
            )}
          >
            {i18n._(description2)}
          </motion.p>
        )}
      </div>
    </div>
  )
}
